import {Component, Input, OnDestroy, OnInit} from '@angular/core';

@Component({
    selector: 'bb-hidden-close',
    templateUrl: './hidden-close.component.html',
    styleUrls: ['./hidden-close.component.scss'],
})
export class HiddenCloseComponent implements OnInit, OnDestroy {
    @Input() showDurationSeconds = 30;
    showCloseTimeout: any;
    showClose = false;

    ngOnInit() {
        if (!!this.showDurationSeconds) {
            this.showCloseTimeout = setTimeout(() => {
                this.showClose = true;
            }, this.showDurationSeconds * 1000);
        } else {
            this.showClose = true;
        }
    }

    ngOnDestroy(): void {
        if (!!this.showCloseTimeout) {
            clearTimeout(this.showCloseTimeout);
        }
    }
}
